import React, { useContext } from "react";
import { InputLabel, Grid, Container, Select, MenuItem } from '@mui/material';
import { DraftYearContext } from "../../contexts/DraftYearContext";
import { useLocation } from 'react-router-dom';


function DraftYearPicker() {
    const { draftYear, setDraftYear } = useContext(DraftYearContext);
    const draftYears = [2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019];

    const handleYearChange = (event) => {
        setDraftYear(event.target.value);
    };

    const location = useLocation();

    const pathsWithDraftYear = ["/", "/consensus-rankings", "/draft-hub", "/media-rankings", "/mocks-and-rankings", "/independent-rankings", "/draft-order", "/draft-results", "/players", "/arrival-rankings"];

    const isDraftYearPickerPage = () => {
        if (pathsWithDraftYear.includes(location.pathname)) {
            return true;
        }
        return false;
    };

    const labelSx = {
        color: 'var(--text-muted)',
        fontFamily: "'Inter', sans-serif",
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginBottom: '4px',
    };

    const selectSx = {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        color: 'var(--text-primary)',
        fontFamily: "'Inter', sans-serif",
        fontSize: '13.5px',
        fontWeight: 600,
        borderRadius: '8px',
        minWidth: '110px',
        transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--border-default)',
        },
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--border-strong)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--brand)',
            borderWidth: '1px',
        },
        '&.Mui-focused': {
            boxShadow: '0 0 0 3px rgba(126, 168, 98, 0.18)',
        },
        '& .MuiSvgIcon-root': {
            color: 'var(--text-secondary)',
        },
    };

    return (
        <div>
            {isDraftYearPickerPage() &&
                <Container className="draft-year-container" >
                    <Grid container spacing={2} className="draft-pick-detail" justifyContent="right">
                        <Grid item xs={12} sm={12} md={2}>
                            <InputLabel className="drop-down-label" sx={labelSx}>Draft Year</InputLabel>
                            <Select
                                value={draftYear}
                                autoWidth
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                className="drop-down"
                                onChange={handleYearChange}
                                size="small"
                                sx={selectSx}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: 'var(--bg-surface-2)',
                                            border: '1px solid var(--border-default)',
                                            borderRadius: '10px',
                                            boxShadow: 'var(--shadow-lg)',
                                            mt: 0.5,
                                            '& .MuiMenuItem-root': {
                                                fontFamily: "'Inter', sans-serif",
                                                fontSize: '13.5px',
                                                color: 'var(--text-primary)',
                                                borderRadius: '6px',
                                                margin: '2px 4px',
                                                transition: 'background-color 0.12s ease',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(255, 255, 255, 0.06)',
                                                },
                                                '&.Mui-selected': {
                                                    backgroundColor: 'rgba(126, 168, 98, 0.15)',
                                                    color: 'var(--brand-strong)',
                                                    fontWeight: 600,
                                                },
                                                '&.Mui-selected:hover': {
                                                    backgroundColor: 'rgba(126, 168, 98, 0.22)',
                                                },
                                            },
                                        },
                                    },
                                }}
                            >
                                {draftYears.map((draftYear) => (
                                    <MenuItem key={draftYear} value={draftYear}>
                                        {draftYear}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                </Container>}
        </div>
    );
}

export default DraftYearPicker;